module.exports = __webpack_public_path__ + "img/resource-tech-image-01.e64647fa.jpg";